<template>
  <div class="mx-md-12 px-sm-12 text-center">
    <p class="display-1 primary--text text-center">Praktikumsplätze</p>
    <p align="justify">
      Wir freuen uns, Sie hier begrüßen zu dürfen. 
      Gerne stehen wir mit unseren Praktikumsbegleiterinnen als Praktikumsstelle für Ausbildungen 
      im Gesundheits- und Pflegebereich bereit. 
      Freie Praktikumsstellen haben wir für FachsozialbetreuerInnen, PflegefachassistenInnen, 
      HeimhelferInnen und Studierende der Gesundheits- und Krankenpflege.
    </p>

    <p align="justify">
      Auch Interessierte vor Ausbildungsbeginn (40-Stunden-Praktikum, Schnuppern, …) 
      sind jederzeit gerne willkommen.
    </p>
      
    <p align="justify">
      <strong>Sie haben Interesse an einem Praktikumsplatz in unserem Heim - dann melden Sie sich unter 07683/8553</strong>
    </p>

    <img
    class="hidden-sm-and-down"
    width="50%"
    :src="require('@/assets/Angebote/Praktikumsplaetze/Holzkloetze.jpg')"
    />

    <img
    class="hidden-md-and-up"
    width="100%"
    :src="require('@/assets/Angebote/Praktikumsplaetze/Holzkloetze.jpg')"
    />
  </div>
</template>

<script>
  export default {
    name: 'praktikumsplaetze',
  }
</script>
